import { combineReducers, applyMiddleware, createStore } from "redux";
import { headerIndexReducer } from './Redux/Reducers/apiReducers';
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

const finalReducers = combineReducers({
 
  get_headerIndex_Reducer: headerIndexReducer,
  
});
const initialState = {};
const composeEnhancers = composeWithDevTools({});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["get_headerIndex_Reducer"],
};
const persistedReducer = persistReducer(persistConfig, finalReducers);
const store = createStore(
  persistedReducer,
  initialState,
  composeEnhancers(applyMiddleware(thunk))
);

let persistor = persistStore(store);
persistor.subscribe(() => {
  store.dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: false });
  const state = store.getState();
  
});

export { persistor, store };